import { ActionTypes } from './types';

export function setCreatingView(value: boolean, name?: string) {
  return { type: ActionTypes.SET_IS_CREATING_VIEW, value, name }
}

export function setSelectedView(value: UserView | undefined) {
  return { type: ActionTypes.SET_SELECTED_VIEW, value }
}
